<button
  @click="openReclassify"
  class="btn btn-default btn-flat float-right"
  >
  Reclassificação
</button>
&nbsp;
<button
  @click="openCredentials"
  class="btn btn-default btn-flat float-right"
  >
  Credenciais
</button>
&nbsp;
